import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { JobService } from "../../Network/services/JobService";
import { planService } from "../../Network/services/planService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import "./PostJobView.css";
import Select from "react-dropdown-select";
import Geocode from "react-geocode";
import Modal from "react-modal";
import WarningIcon from "../../assets/images/warning_icon.png";
import CategoryModal from "../CategoryModal";
import LocationAutocomplete from "../LocationAutocomplete/LocationAutocomplete";

const mapStateToProps = (state) => ({
  ...state.articleList,
  selectedPlan: state.common.selectedPlan,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
  dispatch,
});

const PostJobView = (props) => {
  let location = useLocation();
  let history = useHistory();

  
  const { selectedPlan } = props;

  const [scopefile, setScopefile] = useState({ name: "" });
  const [scopeValidation, setScopeValidation] = useState("");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setselectedCategory] = useState("");
  const [budget, setBudget] = useState("");
  const [paymentterms, setPaymentterms] = useState("");
  const [jobtitle, setJobTitle] = useState("");
  const [about, setAbout] = useState("");
  const [joblocation, setLocation] = useState("");
  const [tags, setTags] = useState([]);
  const [targetDate, setTargeDate] = useState("");
  const [taketheWork, setTakethework] = useState("");
  const [addSkillstate, setAddSkillstate] = useState("");

  const [amount, setAmount] = useState("");
  const [fromAmount, setFromAmount] = useState("");
  const [toAmount, setToAmount] = useState("");
  const [jobtitleValidation, setJobTitleValidation] = useState("");
  const [selectedCategoryValidation, setselectedCategoryValidation] = useState(
    ""
  );
  const [locationValidation, setLocationValidation] = useState("");
  const [takeworkValidation, setTakeworkValidation] = useState("");
  const [budgetValidation, setBudgetValidation] = useState("");
  const [closedateValidation, setClosedateValidation] = useState("");
  const [paymenttermsValidation, setPaymenttermsValidation] = useState("");
  const [amountValidation, setAmountValidation] = useState("");
  const [skillsValidation, setSkillsValidation] = useState("");
  const [descriptionValidation, setDescriptionValidation] = useState("");
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [pickerValue, setPickerValue] = useState(1);
  const [fileValidtion, setFilevalidation] = useState("");
  const [attachement, setAttachement] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [categoryView, setCategoryView] = useState(false);
  const [expandedParentCategory, setExpandedParentCategory] = useState(null);
  const [selectedChildCategory, setSelectedChildCategory] = useState('');
  const [selectedParentCategory, setSelectedParentCategory] = useState('');
  const [selected, setSelected] = useState("By Terms");
  const [selectedPlanState, setSelectedPlanState] = useState("");
  const [plansList, setPlansList] = useState([]);
  const [plansLoading, setPlansLoading] = useState(false);
  const [planValidation, setPlanValidation] = useState("");
  const [selectedPlanDropdown, setSelectedPlanDropdown] = useState([]);
  const [showNoPlanModal, setShowNoPlanModal] = useState(false);
  const [isSelectedPlanPremium, setIsSelectedPlanPremium] = useState(true);
  
  const checkActivePlansAndFetchPlans = async () => {
    try {
      setPlansLoading(true);
      const formData = new FormData();
      const response = await planService.getPlansAndMyPlans(formData);
      
      let responseData = response;
      if (response?.data) {
        responseData = response.data;
      }
      
      const isStatus200 = response?.status === 200 || responseData?.status === 200;
      
      if (response && isStatus200) {
        const subscribedPlans = responseData?.data?.subscribed_plans || 
                               responseData?.subscribed_plans || 
                               response.subscribed_plans || 
                               [];
        const plans = responseData?.data?.plans || 
                     responseData?.plans || 
                     response.plans || 
                     [];
        
        const activePlans = subscribedPlans.filter(plan => !plan.job_id && plan.status && plan.status.toLowerCase() === "active");
        
        if (activePlans && activePlans.length > 0) {
          if (selectedPlan) {
            const planData = activePlans.find(plan => plan.user_plan_id === selectedPlan.id);
            
            if (planData) {
              const isPlanUsed = !!planData.job_id;
              if (isPlanUsed !== selectedPlan.status) {
                props.dispatch({ 
                  type: 'SELECT_PLAN', 
                  payload: { ...selectedPlan, status: isPlanUsed } 
                });
              }
            } else {
              setShowNoPlanModal(true);
            }
          }
        } else {
          setShowNoPlanModal(true);
        }
        
        
        const unusedPlans = subscribedPlans
          .filter(plan => (!plan.job_id && plan.status && plan.status.toLowerCase() === "active"))
          .map(plan => {
            const planData = plans.find(p => p.plan_id === plan.plan_id);
            if (!planData) {
              return null;
            }
            return {
              label: `${planData.subscription_name} (Plan ID: #${plan.user_plan_id.toString().padStart(5, '0')})`,
              value: plan.user_plan_id,
              planId: plan.plan_id,
              userPlanId: plan.user_plan_id,
              is_premium: planData.is_premium || 0
            };
          })
          .filter(plan => plan !== null);
        
        unusedPlans.push({
          label: "Buy a Plan",
          value: "buy_plan",
          planId: null,
          userPlanId: null
        });
        
        setPlansList(unusedPlans);
      } else {
        setShowNoPlanModal(true);
        toast.error('Failed to fetch plans data');
      }
    } catch (error) {
      setShowNoPlanModal(true);
      toast.error('Failed to fetch plans data');
    } finally {
      setPlansLoading(false);
    }
  };

  useEffect(() => {
    checkActivePlansAndFetchPlans();
  }, [selectedPlan, history, props.dispatch]);


  useEffect(() => {
    if (selectedPlan && plansList.length > 0) {
      const planOption = plansList.find(plan => plan.value === selectedPlan.id);
      if (planOption) {
        setSelectedPlanDropdown([planOption]);
        setSelectedPlanState(selectedPlan.id);
        const isPremium = planOption.is_premium === "1" || planOption.is_premium === 1;
        setIsSelectedPlanPremium(isPremium);
        
        if (planOption.is_premium === "0" || planOption.is_premium === 0) {
          setPaymentterms("On Completion");
        } else {
          setPaymentterms("");
        }
      }
    }
  }, [selectedPlan, plansList]);

  useEffect(() => {
    if (!isSelectedPlanPremium && paymentterms !== "On Completion") {
      setPaymentterms("On Completion");
    }
  }, [isSelectedPlanPremium]);


  const handleViewPlans = () => {
    setShowNoPlanModal(false);
    props.dispatch({ type: 'CLEAR_SELECTED_PLAN' });
    history.push('/plans');
  };

  const handleCancelModal = () => {
    setShowNoPlanModal(false);
    props.dispatch({ type: 'CLEAR_SELECTED_PLAN' });
    history.push("/");
  };

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const categoriesData = localStorage.getItem('categories_with_sub_categories');
      
      if (categoriesData) {
        const parsedData = JSON.parse(categoriesData);
        
        if (parsedData && Array.isArray(parsedData)) {
          const parentCategories = parsedData
            .filter(parent => 
              parent.status !== 'Deactive' && 
              parent.fws_categories && 
              parent.fws_categories.length > 0
            )
            .map(parent => ({
              ...parent,
              fws_categories: parent.fws_categories
                .filter(child => child.status !== 'Deactive')
                .sort((a, b) => 
                  a.category_name.localeCompare(b.category_name)
                )
            }))
            .filter(parent => parent.fws_categories.length > 0)
            .sort((a, b) => a.parent_category_name.localeCompare(b.parent_category_name));
          
          setCategoryData(parentCategories);
        }
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

 const onCompletion = (e) => {
    e.preventDefault();
    setSelected("By Completion");
  };
  const onbyTerms = (e) => {
    e.preventDefault();
    setSelected("By Terms");
  };
  const onMilestone = (e) => {
    e.preventDefault();
    setSelected("By Milestone");
  };

 

  function onFilesChange(event) {
    const files = Array.from(event.target.files);
    
    if (uploadedFiles.length + files.length > 5) {
      toast.dismiss(); 
      toast.error("Maximum 5 files allowed", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: "file-count-limit" 
      });
      return;
    }

    const maxFileSize = 2 * 1024 * 1024; 
    const invalidFiles = files.filter(file => file.size > maxFileSize);
    
    if (invalidFiles.length > 0) {
      toast.dismiss(); 
      toast.error("Each file must be less than 2MB", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: "file-size-limit" 
      });
      return;
    }

    const newFiles = [...uploadedFiles, ...files];
    setUploadedFiles(newFiles);
    
    const newPreviews = [];
    files.forEach((file, index) => {
      const fileId = Date.now() + index;
      const filePreview = {
        id: fileId,
        file: file,
        name: file.name,
        type: file.type,
        size: file.size
      };

      const reader = new FileReader();
      reader.onload = (e) => {
        filePreview.preview = e.target.result;
        setFilePreviews(prev => [...prev, filePreview]);
      };
      reader.readAsDataURL(file);
    });
    
    if (files.length > 0) {
      setAttachement(files[0]);
    }
  }

  const getFileIcon = (fileType) => {
    if (fileType.startsWith('image/')) return '🖼️';
    if (fileType.includes('pdf')) return '📄';
    if (fileType.includes('word') || fileType.includes('document')) return '📝';
    if (fileType.includes('excel') || fileType.includes('spreadsheet')) return '📊';
    if (fileType.includes('powerpoint') || fileType.includes('presentation')) return '📈';
    if (fileType.includes('text')) return '📃';
    if (fileType.includes('zip') || fileType.includes('rar') || fileType.includes('archive')) return '📦';
    if (fileType.includes('video')) return '🎥';
    if (fileType.includes('audio')) return '🎵';
    return '📎'; 
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  const removeFile = (fileId) => {
    const fileToRemove = filePreviews.find(f => f.id === fileId);
    if (fileToRemove) {
      setUploadedFiles(prev => prev.filter(f => f !== fileToRemove.file));
      setFilePreviews(prev => prev.filter(f => f.id !== fileId));
      if (attachement === fileToRemove.file) {
        const remainingFiles = uploadedFiles.filter(f => f !== fileToRemove.file);
        setAttachement(remainingFiles.length > 0 ? remainingFiles[0] : {});
      }
    }
  };

  const toggleAccordion = (parentId) => {
    setExpandedParentCategory(expandedParentCategory === parentId ? null : parentId);
  };

  const handleChildCategorySelect = (parentName, childName) => {
    setSelectedParentCategory(parentName);
    setSelectedChildCategory(childName);
    
    const parentCategory = categoryData.find(cat => cat.parent_category_name === parentName);
    if (parentCategory) {
      const childCategory = parentCategory.fws_categories.find(child => child.category_name === childName);
      if (childCategory) {
        setselectedCategory(childCategory.id); 
        setCategoryView(false); 
      }
    }
  };

  let back = (e) => {
    e.preventDefault();
    props.dispatch({ type: 'CLEAR_SELECTED_PLAN' });
    history.goBack();
  };
 

  const onFilesError = (error, file) => {


    setFilevalidation(error.message);
  };
  const handletagChange = (tags) => {
    const filteredTags = tags
      .map(tag => tag.trim()) 
      .filter(tag => tag.length > 0); 
    
    if (filteredTags.length > 5) {
      toast.dismiss(); 
      toast.error("Maximum 5 skills allowed", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: "skills-limit" 
      });
      return;
    }
    
    setTags(filteredTags);
  };
  const options = [
    { name: "Swedish", value: "sv" },
    { name: "English", value: "en" },
    {
      type: "group",
      name: "Group name",
      items: [{ name: "Spanish", value: "es" }],
    },
  ];
  const resetValidation = () => {
    setPlanValidation("");
    setJobTitleValidation("");
    setselectedCategoryValidation("");
    setLocationValidation("");
    setTakeworkValidation("");
    setBudgetValidation("");
    setClosedateValidation("");
    setPaymenttermsValidation("");
    setAmountValidation("");
    setSkillsValidation("");
    setDescriptionValidation("");
    
    const planDropdown = document.querySelector('.plan-dropdown .react-dropdown-select');
    const jobTitleField = document.querySelector('input[placeholder="*Job Title"]');
    const categoryField = document.querySelector('.react-dropdown-select');
    const locationField = document.querySelector('input[placeholder="*Add Location"]');
    const takeWorkField = document.querySelector('.react-datepicker__input-container input');
    const skillsField = document.querySelector('.react-tagsinput');
    const budgetField = document.querySelectorAll('.react-dropdown-select')[1];
    const amountField = document.querySelector('input[placeholder="*Amount (INR)"]') || document.querySelector('input[placeholder="*From Amount (INR)"]');
    const targetDateField = document.querySelectorAll('.react-datepicker__input-container input')[1];
    const paymentTermsField = document.querySelectorAll('.react-dropdown-select')[2];
    
    [planDropdown, jobTitleField, categoryField, locationField, takeWorkField, skillsField, budgetField, amountField, targetDateField, paymentTermsField].forEach(field => {
      if (field) {
        field.style.border = '';
        field.classList.remove('validation-error', 'shake');
      }
    });
  };
  const addShakeEffect = (element) => {
    if (element) {
      element.style.border = '1px solid #dc3545';
      element.classList.add('validation-error', 'shake');
      setTimeout(() => {
        element.style.removeProperty('border');
        element.classList.remove('validation-error', 'shake');
      }, 3000);
    }
  };

  const scrollToFirstError = (element) => {
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  };

  const isFormValid = () => {
    return selectedPlanState !== "" && 
           jobtitle !== "" && jobtitle.length > 3 &&
           selectedCategory !== "" &&
           joblocation !== "" &&
           taketheWork !== "" &&
           tags.length > 0 &&
           budget !== "" &&
           (budget === "Fixed Price" ? amount !== "" : fromAmount !== "" && toAmount !== "") &&
           targetDate !== "" &&
           paymentterms !== "";
  };

  const submitquote = () => {
    let validationerrors = "no";
    setLoading(true);
    resetValidation();
    
    let firstErrorElement = null;
    
    if (selectedPlanState == "") {
      setPlanValidation("Please select a plan");
      const planDropdown = document.querySelector('.plan-dropdown .react-dropdown-select');
      addShakeEffect(planDropdown);
      if (!firstErrorElement) firstErrorElement = planDropdown;
      validationerrors = "yes";
    }
    if (jobtitle == "" || jobtitle.length <= 3) {
      setJobTitleValidation("Please Enter valid jobtitle");
      const jobTitleField = document.querySelector('input[placeholder="*Job Title"]');
      addShakeEffect(jobTitleField);
      if (!firstErrorElement) firstErrorElement = jobTitleField;
      validationerrors = "yes";
    } else if (jobtitle.length > 30) {
      setJobTitleValidation("Job title must be 30 characters or less");
      const jobTitleField = document.querySelector('input[placeholder="*Job Title"]');
      addShakeEffect(jobTitleField);
      if (!firstErrorElement) firstErrorElement = jobTitleField;
      validationerrors = "yes";
    } else if (jobtitle.length > 30) {
      setJobTitleValidation("Job title must be 30 characters or less");
      const jobTitleField = document.querySelector('input[placeholder="*Job Title"]');
      addShakeEffect(jobTitleField);
      if (!firstErrorElement) firstErrorElement = jobTitleField;
      validationerrors = "yes";
    }
    if (selectedCategory == "") {
      setselectedCategoryValidation("Please select a category");
      const categoryField = document.querySelector('.react-dropdown-select');
      addShakeEffect(categoryField);
      if (!firstErrorElement) firstErrorElement = categoryField;
      validationerrors = "yes";
    }
    if (joblocation == "") {
      setLocationValidation("Please enter a valid location");
      const locationField = document.querySelector('input[placeholder="*Add Location"]');
      addShakeEffect(locationField);
      if (!firstErrorElement) firstErrorElement = locationField;
      validationerrors = "yes";
    }
    if (taketheWork == "") {
      setTakeworkValidation("Please enter a valid Take the work");
      const takeWorkField = document.querySelector('.react-datepicker__input-container input');
      addShakeEffect(takeWorkField);
      if (!firstErrorElement) firstErrorElement = takeWorkField;
      validationerrors = "yes";
    }
    if (tags.length == 0) {
      setSkillsValidation("Type and press Enter for each skill to add");
      const skillsField = document.querySelector('.react-tagsinput');
      addShakeEffect(skillsField);
      if (!firstErrorElement) firstErrorElement = skillsField;
      validationerrors = "yes";
    }
    
    if (about.length > 350) {
      setDescriptionValidation("Description must be 350 characters or less");
      const descriptionField = document.querySelector('textarea[placeholder="*Job Description"]');
      addShakeEffect(descriptionField);
      if (!firstErrorElement) firstErrorElement = descriptionField;
      validationerrors = "yes";
    }
    
    const invalidSkills = tags.filter(skill => skill.length > 30);
    if (invalidSkills.length > 0) {
      setSkillsValidation("Each skill must be 30 characters or less");
      const skillsField = document.querySelector('.react-tagsinput');
      addShakeEffect(skillsField);
      if (!firstErrorElement) firstErrorElement = skillsField;
      validationerrors = "yes";
    }
    if (budget == "") {
      setBudgetValidation("Please select a budget");
      const budgetField = document.querySelectorAll('.react-dropdown-select')[1];
      addShakeEffect(budgetField);
      if (!firstErrorElement) firstErrorElement = budgetField;
      validationerrors = "yes";
    }
    if (budget == "Fixed Price") {
      if (amount == "") {
        setAmountValidation("Please enter a valid amount");
        const amountField = document.querySelector('input[placeholder="*Amount (INR)"]');
        addShakeEffect(amountField);
        if (!firstErrorElement) firstErrorElement = amountField;
        validationerrors = "yes";
      } else if (isNaN(amount) || parseFloat(amount) <= 0) {
        setAmountValidation("Please enter a valid numeric amount");
        const amountField = document.querySelector('input[placeholder="*Amount (INR)"]');
        addShakeEffect(amountField);
        if (!firstErrorElement) firstErrorElement = amountField;
        validationerrors = "yes";
      } else if (isNaN(amount) || parseFloat(amount) <= 0) {
        setAmountValidation("Please enter a valid numeric amount");
        const amountField = document.querySelector('input[placeholder="*Amount (INR)"]');
        addShakeEffect(amountField);
        if (!firstErrorElement) firstErrorElement = amountField;
        validationerrors = "yes";
      }
    } else {
      if (fromAmount == "") {
        setAmountValidation("Please enter a valid range from amount");
        const fromAmountField = document.querySelector('input[placeholder="*From Amount (INR)"]');
        addShakeEffect(fromAmountField);
        if (!firstErrorElement) firstErrorElement = fromAmountField;
        validationerrors = "yes";
      } else if (isNaN(fromAmount) || parseFloat(fromAmount) <= 0) {
        setAmountValidation("Please enter a valid numeric from amount");
        const fromAmountField = document.querySelector('input[placeholder="*From Amount (INR)"]');
        addShakeEffect(fromAmountField);
        if (!firstErrorElement) firstErrorElement = fromAmountField;
        validationerrors = "yes";
      } else if (isNaN(fromAmount) || parseFloat(fromAmount) <= 0) {
        setAmountValidation("Please enter a valid numeric from amount");
        const fromAmountField = document.querySelector('input[placeholder="*From Amount (INR)"]');
        addShakeEffect(fromAmountField);
        if (!firstErrorElement) firstErrorElement = fromAmountField;
        validationerrors = "yes";
      }
      
      if (toAmount == "") {
        setAmountValidation("Please enter a valid range to amount");
        const toAmountField = document.querySelector('input[placeholder="*To Amount (INR)"]');
        addShakeEffect(toAmountField);
        if (!firstErrorElement) firstErrorElement = toAmountField;
        validationerrors = "yes";
      } else if (isNaN(toAmount) || parseFloat(toAmount) <= 0) {
        setAmountValidation("Please enter a valid numeric to amount");
        const toAmountField = document.querySelector('input[placeholder="*To Amount (INR)"]');
        addShakeEffect(toAmountField);
        if (!firstErrorElement) firstErrorElement = toAmountField;
        validationerrors = "yes";
      }
      
      if (fromAmount && toAmount && !isNaN(fromAmount) && !isNaN(toAmount) && parseFloat(toAmount) <= parseFloat(fromAmount)) {
        setAmountValidation("To amount must be greater than from amount");
        const toAmountField = document.querySelector('input[placeholder="*To Amount (INR)"]');
        addShakeEffect(toAmountField);
        if (!firstErrorElement) firstErrorElement = toAmountField;
        validationerrors = "yes";
      }
      
      if (!validationerrors || validationerrors !== "yes") {
        setAmount(fromAmount + " to " + toAmount);
      }
    }

    if (targetDate == "") {
      setClosedateValidation("Please select a Targeted close date");
      const targetDateField = document.querySelectorAll('.react-datepicker__input-container input')[1];
      addShakeEffect(targetDateField);
      if (!firstErrorElement) firstErrorElement = targetDateField;
      validationerrors = "yes";
    } else if (targetDate && taketheWork) {
      const oneYearFromStart = moment(taketheWork).add(1, 'year');
      const selectedTargetDate = moment(targetDate);
      
      if (selectedTargetDate.isAfter(oneYearFromStart, 'day')) {
        setClosedateValidation("Targeted Close Date must be within one year from Take the Work date");
        const targetDateField = document.querySelectorAll('.react-datepicker__input-container input')[1];
        addShakeEffect(targetDateField);
        if (!firstErrorElement) firstErrorElement = targetDateField;
        validationerrors = "yes";
        toast.dismiss();
        toast.error("Targeted Close Date must be within one year from Take the Work date", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: "target-date-validation-submit"
        });
      }
    }
    if (paymentterms == "") {
      setPaymenttermsValidation("Please select a Payment Terms");
      const paymentTermsField = document.querySelectorAll('.react-dropdown-select')[2];
      addShakeEffect(paymentTermsField);
      if (!firstErrorElement) firstErrorElement = paymentTermsField;
      validationerrors = "yes";
    }

    if(validationerrors == "yes"){
      setLoading(false);
      if (firstErrorElement) {
        scrollToFirstError(firstErrorElement);
      }
      toast.error("Please fill in all required fields", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const skillsString = tags.join(",");

    const form = new FormData();
    form.append("job_title", jobtitle);
    form.append("category", selectedChildCategory);
    form.append("child_category_id", selectedCategory);
    form.append("job_description", about);
    form.append("job_location", joblocation);
    form.append("skills", skillsString);
    form.append(
      "take_work",
      moment(new Date(taketheWork)).format("DD-MM-yyyy")
    );
    form.append("budjet", budget);
    form.append(
      "target_closed_date",
      moment(new Date(targetDate)).format("MM-DD-yyyy")
    );
    form.append("payment_term", paymentterms);
    form.append("amount", budget == "Fixed Price"?amount:fromAmount + " to " + toAmount);

    if (uploadedFiles.length > 0) {
      for(let i = 0; i < uploadedFiles.length; i++) {
      form.append(`attach_file[${i}]`, uploadedFiles[i]);
    }
  }
   form.append("user_plan_id", selectedPlanState);

    JobService.postjob(form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          
          props.dispatch({ type: 'CLEAR_SELECTED_PLAN' });
          history.push("/mycontracts");


        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {showNoPlanModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div className="confirmation-modal" style={{
            backgroundColor: 'white',
            height: '270px',
            width: '360px',
            borderRadius: '10px',
            padding: '20px'
          }}>
            <div className="modal-content" style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              backgroundColor: 'white',
              rowGap: '8px',
              flexDirection: 'column'
            }}>
              <div className="warning-icon-confirmation" style={{
                width: '80px',
                height: '80px',
                borderRadius: '40px',
                border: '1px solid #FDBE47',
                display: 'grid',
                placeItems: 'center',
                backgroundColor: '#FFF7F1'
              }}>
                <img 
                  src={WarningIcon} 
                  alt="warning" 
                  className="warning-icon-for-delete"
                  style={{ width: '30px' }}
                />
              </div>
              
              <h3 className="pop-up-delete-heading-confirmation" style={{
                fontSize: '16px',
                fontWeight: '500',
                marginTop: '6px',
                margin: '0'
              }}>
                No Active Plans
              </h3>
              
              <p className="pop-up-delete-message-confirmation" style={{
                fontSize: '14px',
                fontWeight: '400',
                textAlign: 'center',
                margin: '0'
              }}>
                You need to have an active plan before posting a job. Would you like to view available plans?
              </p>
              
              <div className="button-section-delete-and-cancel-delete" style={{
                display: 'flex',
                columnGap: '20px',
                justifyContent: 'space-between',
                marginTop: '10px'
              }}>
                <button
                  onClick={handleCancelModal}
                  className="cancel-button"
                  style={{
                    border: '1px solid #F57E1F',
                    color: '#F57E1F',
                    fontWeight: '300',
                    width: '130px',
                    height: '40px',
                    backgroundColor: 'transparent',
                    borderRadius: '20px'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleViewPlans}
                  className="confirm-button"
                  style={{
                    border: '1px solid #F57E1F',
                    color: 'white',
                    fontWeight: '300',
                    width: '130px',
                    height: '40px',
                    backgroundColor: '#F57E1F',
                    borderRadius: '20px'
                  }}
                >
                  Purchase Plans
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="explore explore1">
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
            20%, 40%, 60%, 80% { transform: translateX(5px); }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .shake {
            animation: shake 0.5s ease-in-out;
          }
          .validation-error {
            border: 1px solid #dc3545 !important;
          }
          .btn-disabled {
            background-color: #dbd9da !important;
            opacity: 0.6 !important;
          }
          .error {
            font-size: 12px !important;
            color: #dc3545 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
          }
          .form-control {
            margin-bottom: 0 !important;
          }
          .form-group {
            margin-bottom: 15px !important;
          }
            .react-dropdown-select {
            height: 40px !important;
            }
          .react-dropdown-select:hover
          {
          border-color: #BCBCBC !important;
            outline: none !important;
            box-shadow: none !important;
          }
          .react-dropdown-select:focus,
          .react-dropdown-select:focus-within {
            border-color: #F57E1F !important;
            outline: none !important;
            box-shadow: none !important;
          }
        `
      }} />
      <LoadingOverlay>
        <div className="container">
          <div className="banner">
            <div className="row">
              <div className="col-md-12">
                <div className="breadcrumps">
                  <ul>
                    <li>
                      <div onClick={back}>
                        <a href="#">
                          <i className="bx bx-chevron-left" /> Back to all jobs
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="explore-details post-new-job">
            <div className="row">
              <div className="col-md-7">
                <h1>Post a New Job</h1>
                <p>
                  Future Workforce Solutions needs the below information to help
                  you better.
                </p>
                <div className="form-group plan-dropdown">
                  <Select
                    className="form-control"
                    options={plansList}
                    values={selectedPlanDropdown}
                    placeholder="Choose Plan*"
                    onChange={(values) => {
                      if (values.length > 0) {
                        const selectedValue = values[0].value;
                        if (selectedValue === "buy_plan") {
                          history.push('/plans');
                        } else {
                          const selectedPlan = values[0];
                          const isPremium = selectedPlan.is_premium === "1" || selectedPlan.is_premium === 1;
                          
                          setSelectedPlanState(selectedValue);
                          setSelectedPlanDropdown(values);
                          setIsSelectedPlanPremium(isPremium);
                          
                          if (selectedPlan.is_premium === "0" || selectedPlan.is_premium === 0) {
                            setPaymentterms("On Completion");
                          } else {
                            setPaymentterms("");
                          }
                        }
                      }
                    }}
                    disabled={plansLoading}
                  />
                  <label className="error">{planValidation}</label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name
                    className="form-control"
                    required="required"
                    placeholder="Job Title*"
                    value={jobtitle}
                    maxLength={30}
                    onChange={(e) => {
                      setJobTitle(e.target.value);
                    }}
                   />
                   <label className="error">{jobtitleValidation}</label>
                </div>
                <div className="form-group">
                  <div 
                    className="form-control category-input"
                    onClick={() => setCategoryView(true)}
                    style={{ cursor: 'pointer' }}
                  >
                    {selectedChildCategory ? `${selectedChildCategory} - ${selectedParentCategory}` : 'Category*'}
                  </div>
                   <label className="error">{selectedCategoryValidation}</label>
                </div>
                <div className="form-group">
                  <textarea
                    name
                    className="form-control"
                    placeholder="Provide more details about the Job."
                    defaultValue={""}
                    value={about}
                    maxLength={350}
                    onChange={(e) => {
                      setAbout(e.target.value);
                    }}
                   />
                   <label className="error">{descriptionValidation}</label>
                </div>
                <div className="form-group">
                  <LocationAutocomplete
                    value={joblocation}
                    onChange={setLocation}
                    placeholder="Add Location*"
                    locationType="job"
                    required={true}
                  />
                  <label className="error">{locationValidation}</label>
                </div>
                <div className="form-group">
                  {/* <select className="form-control">
                    <option selected="selected">*Targeted Close Date</option>
                  </select> */}
                  <DatePicker
                    className="form-control"
                    selected={taketheWork}
                    minDate={new Date()}
                    onChange={(date) => setTakethework(date)}
                    placeholderText="Job Start Date (MM/DD/YYYY)*"
                  />
                </div>
               <div className="form-group" style={(Array.isArray(tags) && tags.join('').length > 55) ?  tags.join('').length > 110 ? { height: '135px' } : { height: '105px' } : undefined}>
                  {/* <select className="form-control">
                    <option selected="selected">*Budget</option>
                  </select> */}
                  <TagsInput
                    className={`form-control tags-input-control ${Array.isArray(tags) && tags.join('').length > 55 ? tags.join('').length > 110 ? 'expanded expanded-tags-input-125' : 'expanded expanded-tags-input-105' : ''}`}
                    value={tags}
                    onChange={handletagChange}
                    inputProps={{
                      placeholder: tags.length >= 5 ? "" : "Add Skills*",
                      maxLength: 30,
                      disabled: tags.length >= 5,
                    }}
                   />
                   <label className="error">{skillsValidation}</label>
                </div>
                <div className="form-group">
                  <Select
                    className="form-control"
                    options={[
                      { label: "Fixed Price", value: "Fixed Price" },
                      { label: "Price Range", value: "Price Range" },
                    ]}
                    placeholder="Budget*"
                    onChange={(values) => {

                      const selectedOption = Array.isArray(values) && values.length > 0 ? values[0] : null;
                      if (!selectedOption) {
                        return;
                      }
                      setBudget(selectedOption.value);
                    }}
                   />
                   <label className="error">{budgetValidation}</label>
                </div>
                {budget == "Fixed Price" ? (
                  <div className="form-group">
                    <input
                      type="text"
                      name
                      className="form-control"
                      required="required"
                      placeholder="Amount (INR)*"
                      value={amount}
                      min="1"
                      max="1000000"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value && !/^\d+$/.test(value)) {
                          return;
                        }
                        if (value && ( parseInt(value) > 1000000 || parseInt(value) < 1 )) {
                          toast.dismiss();
                          toast.error("Amount should be between 1 and 10,00,000 INR", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            toastId: "amount-limit" // Unique ID to prevent duplicates
                          });
                          return;
                        }
                        setAmount(value);
                      }}
                     />
                     <label className="error">{amountValidation}</label>
                  </div>
                ) : (
                  <div className="form-group amount-range-container">
                    <input
                      type="text"
                      name
                      className="form-control amount-input"
                      required="required"
                      placeholder="From Amount (INR)*"
                      value={fromAmount}
                      min="1"
                      max="999999"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value && !/^\d+$/.test(value)) {
                          return;
                        }
                        if (value && ( parseInt(value) >= 1000000 || parseInt(value) < 1 )) {
                          toast.dismiss();
                          toast.error("Amount should be between 1 and 9,99,999 INR", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            toastId: "from-amount-limit" 
                          });
                          return;
                        }
                        setFromAmount(value);
                      }}
                    />
                    <input
                      type="text"
                      name
                      className="form-control amount-input"
                      required="required"
                      placeholder="To Amount (INR)*"
                      value={toAmount}
                      min="1"
                      max="999999"
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only allow numeric values
                        if (value && !/^\d+$/.test(value)) {
                          return;
                        }
                        if (value && ( parseInt(value) >= 1000000 || parseInt(value) < 1 )) {
                          toast.dismiss();
                          toast.error("Amount should be between 1 and 9,99,999 INR", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            toastId: "to-amount-limit"
                          });
                          return;
                        }
                        setToAmount(value);
                      }}
                    />
                     <label className="error">{amountValidation}</label>
                  </div>
                )}
                <div className="form-group">
                  {/* <select className="form-control">
                    <option selected="selected">*Targeted Close Date</option>
                  </select> */}
                  <DatePicker
                    className="form-control"
                    selected={targetDate}
                    minDate={taketheWork}
                    maxDate={taketheWork ? moment(taketheWork).add(1, 'year').toDate() : moment().add(1, 'year').toDate()}
                    openToDate={taketheWork ? moment(taketheWork).toDate() : moment().toDate()}
                    onChange={(date) => {
                      if (date && taketheWork) {
                        const oneYearFromStart = moment(taketheWork).add(1, 'year');
                        const selectedDate = moment(date);
                        
                        if (selectedDate.isAfter(oneYearFromStart, 'day')) {
                          toast.dismiss();
                          toast.error("Targeted Close Date must be within one year from Take the Work date", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            toastId: "target-date-validation"
                          });
                          return;
                        }
                      }
                      setTargeDate(date);
                    }}
                    placeholderText="Target Close Date (MM/DD/YYYY)*"
                   />
                   <label className="error">{closedateValidation}</label>
                </div>
                <div className="form-group">
                  <Select
                    key={`payment-terms-${isSelectedPlanPremium}-${paymentterms}`}
                    className="form-control"
                    options={[
                      {
                        label: "Term Payment",
                        value: "Term Payment",
                      },
                      {
                        label: "Milestone Payment",
                        value: "Milestone Payment",
                      },
                      { label: "On Completion", value: "On Completion" },
                    ]}
                    values={isSelectedPlanPremium ? 
                      (paymentterms ? [{ label: paymentterms, value: paymentterms }] : []) : 
                      [{ label: "On Completion", value: "On Completion" }]
                    }
                    placeholder="Payment Terms*"
                    disabled={!isSelectedPlanPremium}
                    onChange={(values) => {
                      if (!isSelectedPlanPremium) {
                        return;
                      }
                      const selectedOption = Array.isArray(values) && values.length > 0 ? values[0] : null;
                      if (!selectedOption) {
                        return;
                      }
                      setPaymentterms(selectedOption.value);
                    }}
                   />
                   <label className="error">{paymenttermsValidation}</label>
                   {!isSelectedPlanPremium && (
                     <div className="payment-terms-info">
                       <small className="lite-plan-text-red">
                         Non-premium plans are automatically set to "On Completion" payment terms.
                       </small>
                     </div>
                   )}
                </div>

                <div className="form-group">
                 
                    <label className="filelabel">
                      <div className="file-upload-content">
                        <img src="/assets/images/AddFileIcon.svg" alt="add file" style={{width: '16px', height: '16px'}} />
                        <span className="title">
                          {uploadedFiles.length === 0 
                            ? "Add File" 
                            : uploadedFiles.length === 1 
                              ? uploadedFiles[0].name 
                              : `${uploadedFiles.length} files selected`
                          }
                        </span>
                      </div>
                      <input
                        className="FileUpload1"
                        id="FileInput"
                        name="booking_attachment"
                        type="file"
                        multiple
                        onChange={onFilesChange}
                        onError={onFilesError}
                        accept="image/*,.pdf"
                        accepts={["image/png", "image/jpg",".pdf"]}
                        maxFileSize={2097152}
                        minFileSize={0}
                        clickable
                  
                      />
                    </label>
                </div>

                {filePreviews.length > 0 && (
                  <div className="file-preview-section">
                    <h4>Uploaded Files ({filePreviews.length}/5)</h4>
                    <div className="file-preview-grid">
                      {filePreviews.map((filePreview) => (
                        <div key={filePreview.id} className="file-preview-item">
                          {filePreview.preview ? (
                            <div className="file-preview-container">
                              {filePreview.type.startsWith('image/') ? (
                                <div className="image-preview">
                                  <img 
                                    src={filePreview.preview} 
                                    alt={filePreview.name}
                                    className="preview-image"
                                  />
                                </div>
                              ) : filePreview.type === 'application/pdf' ? (
                                <div className="pdf-preview">
                                  <iframe 
                                    src={filePreview.preview}
                                    className="pdf-iframe"
                                    title={filePreview.name}
                                  />
                                </div>
                              ) : filePreview.type.startsWith('text/') ? (
                                <div className="text-preview">
                                  <iframe 
                                    src={filePreview.preview}
                                    className="text-iframe"
                                    title={filePreview.name}
                                  />
                                </div>
                              ) : filePreview.type.includes('video') ? (
                                <div className="video-preview">
                                  <video 
                                    src={filePreview.preview}
                                    className="preview-video"
                                    controls
                                    title={filePreview.name}
                                  />
                                </div>
                              ) : filePreview.type.includes('audio') ? (
                                <div className="audio-preview">
                                  <audio 
                                    src={filePreview.preview}
                                    className="preview-audio"
                                    controls
                                    title={filePreview.name}
                                  />
                                </div>
                              ) : (
                                <div className="generic-preview">
                                  <iframe 
                                    src={filePreview.preview}
                                    className="generic-iframe"
                                    title={filePreview.name}
                                  />
                                </div>
                              )}
                              <button 
                                className="remove-file-btn"
                                onClick={() => removeFile(filePreview.id)}
                                title="Remove file"
                              >
                                ×
                              </button>
                            </div>
                          ) : (
                            <div className="file-preview">
                              <div className="file-icon">
                                {getFileIcon(filePreview.type)}
                              </div>
                              <button 
                                className="remove-file-btn"
                                onClick={() => removeFile(filePreview.id)}
                                title="Remove file"
                              >
                                ×
                              </button>
                            </div>
                          )}
                          <div className="file-name">{filePreview.name}</div>
                          <div className="file-size">{formatFileSize(filePreview.size)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <button 
                  onClick={submitquote}
                  className={`post-job-button ${!isFormValid() ? 'btn-disabled' : ''}`}
                >
                  Post Job
                </button>
              </div>
              <div className="col-md-5"></div>
            </div>
          </div>
        </div>
        <Loader loading={loading} />
      </LoadingOverlay>
      <Modal
        isOpen={openPopup}
        onRequestClose={() => setOpenPopup(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                Payment Terms
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setOpenPopup(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
              <style type="text/css" dangerouslySetInnerHTML={{__html: "\n\tul.payment-terms li{\n\t\tdisplay: inline-block;\n\t}\n\n\t ul.payment-terms li a {\n    border: 1px solid #CBCBCB;\n    height: 135px;\n    display: block;\n    padding: 20px 10px;\n    text-align: center;\n    border-radius: 10px;\n    width: 130px;\n}\n\nul.payment-terms li a span {\n    display: block;\n    font-size: 14px;\n    color: #434343;\n    margin: 8px 0 0;\n}\n\n.payemnt-terms-sec p {\n    font-size: 14px;\n    font: normal normal medium 14px/25px Poppins;\nletter-spacing: 0px;\ncolor: #434343;\nopacity: 1;\n}\n\nul.payment-terms {\n    text-align: center;\n}\n.payemnt-terms-sec button {\n    background: #F57E1F 0% 0% no-repeat padding-box;\n    border-radius: 4px;\n    opacity: 1;\n    border: 0px;\n    color: #fff;\n    padding: 8px 30px;\n    margin: 30px 0px\n}\n\n" }} />
        <div className="modal-body payemnt-terms-sec">
          <div className="col-md-12">
            <ul className="payment-terms ">
              <li>
              <Link
                        to="#"
                        className={`payment-terms-link ${selected === "By Terms" ? "selected" : ""}`}
                        onClick={onbyTerms}
                      ><img src="/assets/images/terms.png" /><span>By FWS Term</span></Link>
              </li>
              <li>
              <Link
                        to="#"
                        className={`payment-terms-link ${selected === "By Milestone" ? "selected" : ""}`}
                        onClick={onMilestone}
                      ><img src="/assets/images/milestone.png" /><span>By Milestone</span></Link>
              </li>
              <li>
              <Link
                        to="#"
                        className={`payment-terms-link ${selected === "By Completion" ? "selected" : ""}`}
                        onClick={onCompletion}
                      ><img src="/assets/images/completion.png" /><span>By Completion</span></Link>
              </li>
            </ul>
          </div>
          <div className="col-md-12">
            {selected=="By Terms"?(<p>From the overall service price, you will prepay/ escrow 20% before
              starting the work, 60% once the work is started and 20% soon after
              the work is completed. Please note, we will pay the ‘job doer’
              only after receiving your confirmation in the regular intervals
              and once the required % of work is completed. Your payment will be
              safe with us and will be refunded if no work is performed.
            </p>):selected=="By Milestone"?
            (<p>Milestone based payments are customizable according to your need.
              You/ job doer can set the milestone and it’s payment by dividing
              the job into pieces or by period (weekly, monthly) or by any
              nature according to your need. You have to prepay/ escrow the set
              amount for each milestone to begin the work. The payment will be
              released to job doer once each milestone is completed. Your
              payment will be safe with us and will be refunded if no work is
              performed.</p>):(<p>You have to prepay/ escrow the agreed full amount and the same
              will be released to job doer once the job is completed. Your
              payment will be safe with us and will be refunded if no work is
              performed.</p>)}
            
          </div>
          <div className="col-md-12 payment-terms-center">
            <button  onClick={() => setOpenPopup(false)}>Close</button>
          </div>
        </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* CategoryModal: Modal component for selecting job categories with parent and child category hierarchy */}
      <CategoryModal
        isOpen={categoryView}
        onClose={() => setCategoryView(false)}
        categoryData={categoryData}
        selectedChildCategory={selectedChildCategory}
        expandedParentCategory={expandedParentCategory}
        onToggleAccordion={toggleAccordion}
        onSelectCategory={handleChildCategorySelect}
      />
    </section>
    </>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 1000 },
};
export default connect(mapStateToProps, mapDispatchToProps)(PostJobView);
